"use client";
import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { StoreDepartment as StoreDepartmentAsSourceType } from "~/bff/types/StoreDepartment";
import { StoreDepartmentWithImage } from "~/components/store-department-with-image/component";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Nullable } from "~/types/general.types";

import { STORE_DEPARTMENTS_CLASSES } from "./constants";
import { StoreDepartmentsContainer } from "./styled";

export interface StoreDepartmentsProps {
  departments?: Nullable<StoreDepartmentAsSourceType>[];
  storeDepartmentsText?: string;
}

export const StoreDepartments: React.FC<StoreDepartmentsProps> = ({
  departments,
  storeDepartmentsText,
}) => {
  const validDepartments = departments?.filter(
    (department) => !!department?.departmentName && !!department?.departmentImage,
  );

  if (!validDepartments?.length) {
    return null;
  }

  return (
    <StoreDepartmentsContainer {...getTestAutomationProps("store-departments")}>
      <Grid container>
        <Grid
          className={STORE_DEPARTMENTS_CLASSES.hideOnMobile}
          size={{
            md: 3,
          }}
        />
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography
            variant="h4"
            className={STORE_DEPARTMENTS_CLASSES.title}
            {...getTestAutomationProps("title")}
          >
            {storeDepartmentsText}
          </Typography>
          <Box
            className={STORE_DEPARTMENTS_CLASSES.departments}
            {...getTestAutomationProps("departments")}
          >
            <Grid container>
              {validDepartments.map((department, index) => (
                <Grid
                  key={index} //NOSONAR ignored temporarily in scope of MUI update whose changes are not related to array keys
                  size={{
                    xs: 12,
                    sm: 6,
                  }}
                >
                  <StoreDepartmentWithImage {...department} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
        <Grid
          className={STORE_DEPARTMENTS_CLASSES.hideOnMobile}
          size={{
            md: 3,
          }}
        />
      </Grid>
    </StoreDepartmentsContainer>
  );
};
